<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col">
                <h1 class="text-white pt-3 px-3">
                    ประวัติการยกเลิกรายการ
                </h1>
                <p class="text-white pb-0 px-3">
                    ดูสถานะการยกเลิกรายการ
                </p>
            </div>
        </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--7 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <HistoryCancelSearch :search="search"
                                @historyCancel="historyCancel" />
                        </div>
                        <HistoryCancelTable :data="items"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import HistoryCancelSearch from "../components/custom/history/HistoryCancelSearch"
import HistoryCancelTable from "../components/custom/history/HistoryCancelTable"
import validatePop from "../plugins/validatePop.js"
export default {
  name: "historycancel",
  components:{
    HistoryCancelSearch,
    HistoryCancelTable
  },
  data() {
    return {
        search: {
            date:{
                startDate: moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD"),
                endDate: moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD"),
            },
            filter:'',
            status: null
        },
        dataHistory: [],
        busy: false
    };
  },
  mounted() {
      this.historyCancel()
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  methods: {   
    historyCancel(){
        this.busy = true
        let dateStart = moment(this.search.date.startDate).format("YYYY-MM-DD")
        let dateEnd = moment(this.search.date.endDate).format("YYYY-MM-DD")
            this.$http
                .post(this.$API_URL+ "/order/cancel", {
                    start: dateStart,
                    end: dateEnd,
                    filter: this.search.filter,
                    status: this.search.status
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                       this.busy = false;
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                       
                        return false;
                    }
                    this.busy = false;
                    this.dataHistory = res.data.data
                });
    }
  },
  computed: {
    items(){
        let res = []
        if( this.search.status === null ){
            res = this.dataHistory
        }else{
            res = this.dataHistory.filter( detail => {
                return detail.status === this.search.status
            })
        }

        return res
    }
  }
};
</script>

<style></style>
